import { ChangeDetectorRef, Component, Input, OnInit, Self } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';

@Component({
  selector: 'app-text-input',
  templateUrl: './text-input.component.html',
  styleUrls: ['./text-input.component.scss']
})
export class TextInputComponent implements ControlValueAccessor, OnInit {
  @Input() id: string;
  @Input() name: string;
  @Input() placeholder: string;
  @Input() maxLength: number;
  @Input() mandatory: boolean;
  @Input() inputAutofocus: boolean;
  @Input() helpTooltipText: string;
  @Input() inputMask: string;
  @Input() isDisabled: boolean;
  @Input() autofocus = false;
  @Input() value: string;
  @Input() isLoading: boolean;
  //public value: string;

  get isInvalid() {
    return this.controlDirective && this.controlDirective.control.dirty && !this.controlDirective.control.valid;
  }

  constructor(private changeDetectorRef: ChangeDetectorRef, @Self() public controlDirective: NgControl) {
    controlDirective.valueAccessor = this;
  }

  ngOnInit() {
   /* if(this.value != null || this.value !=''){
      this.handleInput();
    }/**/
    this.changeDetectorRef.detectChanges();
    
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public onChange: any = () => {};

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public onTouched: any = () => {};

  public writeValue(value: string) {
    this.value = value;
  }

  public registerOnChange(fn: any) {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  public handleInput() {
    this.onChange(this.value);
  }
}
